const FileService = {
  url: `${process.env.VUE_APP_API_URL}files/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  getFile: async (src) => {
    try {
      const headers = FileService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${src}`, {
        method: "GET",
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default FileService;
